import { makeStyles } from '@material-ui/core/styles';

export function useFiltersStyles() {
    const useStyles = makeStyles((theme) => ({
        accordion: {
            '&:before': {
                display: 'none',
            },
        },
        summary: {
            display: 'none',
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
